import * as Yup from 'yup'

const addBrandSchema = Yup.object().shape({
    name: Yup.string().required('Required'),
    description: Yup.string().required('Required'),
})
export { addBrandSchema }
